<div class="container" *ngIf="!isLoading">
    <div class="header">
        {{ (editMode ? 'mimic-folder.dialog.edit.title' : 'mimic-folder.dialog.new.title') | translate }}
    </div>
    <div class="main">
        <app-channel-text-input
            class="library-category-name"
            [name]="NAME_INPUT_NAME"
            [value]="mimicFolderName"
            label="mimic-folder.dialog.name.legend"
            (onInputChange)="changeMimicFolderName($event)"
            (onFocusChange)="changeMimicFolderName($event)"
            [inputError]="validationErrors?.name"
            [maxLength]="MIMIC_MAX_LENGTH"></app-channel-text-input>
    </div>
    <div class="footer">
        <div class="button-container">
            <button class="text-button" (click)="close()">
                {{ 'dlg.cancel' | translate }}
            </button>
            <app-button
                [disable]="disabledCreateButton()"
                [text]="editMode ? 'dlg.edit' : 'mimics.create.dialog.form.button.create'"
                customFontFamily="NotoSans-SemiBold"
                size="small"
                customFontSize="14px"
                (onClick)="save()"></app-button>
        </div>
    </div>
</div>

<app-loading-spinner
    *ngIf="isLoading"
    class="spinner-component"
    [custom]="true"
    size="80"
    strokeWidth="3"></app-loading-spinner>
